import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import './directive';
import example from '../components/example';
import { get_attendance, save_attendance } from 'api/payroll/salary-scheme/detail';
export default {
  components: {
    example: example
  },
  props: {
    activeObj: {
      type: Object
    }
  },
  data: function data() {
    return {
      tableData: {},
      activeNames: [0],
      activeNames2: [0, 1],
      activeData: this.activeObj.data,
      activeInfo: this.activeObj.data.info,
      cActiveInfo: this.activeObj.data.cInfo,
      // 拷贝数据，判断是否修改
      hourWeekday: {}
    };
  },
  mounted: function mounted() {
    this.activeInfo.selectTable = {};
    this.activeInfo.day_hour = {};
    this.getAttendance();
  },
  methods: {
    getAttendance: function getAttendance() {
      var _this = this;
      get_attendance({
        payroll_sub_project_scheme_id: this.$route.params.id
      }).then(function (res) {
        if (res && res.code === 1) {
          _this.activeInfo.day_hour = res.data.day_hour; // day_hour
          _this.activeInfo.extend = _objectSpread(_objectSpread({}, _this.activeInfo.extend), res.data.extend); // extend
          _this.tableData = res.data.list; // 表格
          // 拷贝初始数据
          _this.cActiveInfo.day_hour = JSON.parse(JSON.stringify(res.data.day_hour || {}));
          _this.cActiveInfo.extend = JSON.parse(JSON.stringify(res.data.extend || {}));
          _this.$nextTick(function () {
            _this.activeNames = [];
            var cSelectTable = {};
            _this.tableData.forEach(function (collapseItem, index) {
              cSelectTable[index] = [];
              // 手风琴默认全部打开
              _this.activeNames.push(index);
              collapseItem.columns.forEach(function (v) {
                if (v.is_select === '1') {
                  cSelectTable[index].push(v);
                  // 表格选中数据
                  _this.$refs['table' + index][0].toggleRowSelection(v, true);
                }
              });
              if (!cSelectTable[index].length) delete cSelectTable[index];
            });
            // 拷贝初始数据
            _this.cActiveInfo.selectTable = JSON.parse(JSON.stringify(cSelectTable));
          });
        }
      });
    },
    tableSelectHandle: function tableSelectHandle(key, arr) {
      var _this2 = this;
      // 表格选中数据
      this.activeInfo.selectTable[key] = arr;
      if (key === 1) {
        this.hourWeekday = {};
        arr.forEach(function (item) {
          _this2.$set(_this2.hourWeekday, item.id, item);
        });
      }
    },
    saveData: function saveData() {
      var res = Object.values(this.activeInfo.selectTable).flat(1);
      var state = res.some(function (item) {
        if (Number(item.type) === 3) {
          return !item.val;
        }
      });
      // 考勤异常为设置添加项 提示 请设置扣款金额
      if (state) {
        this.$message.warning(this.$t('payroll_salary_49'));
        return;
      }
      if (this.$refs.formInput) {
        var validBase = [];
        this.$refs.formInput.forEach(function (item) {
          return item.validate( /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(valid) {
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    validBase.push(valid);
                  case 1:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }());
        });
        if (validBase.includes(false)) {
          this.$message({
            message: this.$t('payroll_salary_5'),
            type: 'warning'
          });
          return false;
        }
      }
      var _this$activeInfo$exte = this.activeInfo.extend,
        cycle_hire_no_leave = _this$activeInfo$exte.cycle_hire_no_leave,
        cycle_no_hire_leave = _this$activeInfo$exte.cycle_no_hire_leave;
      if (Number(cycle_hire_no_leave.type) === 3 && !cycle_hire_no_leave.before && !cycle_hire_no_leave.after) {
        this.$message.warning(this.$t('i18n.cc9c0ad2c58844f3b648b81a638b900c'));
        return;
      }
      if (Number(cycle_no_hire_leave.type) === 3 && !cycle_no_hire_leave.before && !cycle_no_hire_leave.after) {
        this.$message.warning(this.$t('i18n.09935717587f42dc86afa77de80f1404'));
        return;
      }
      return save_attendance({
        payroll_sub_project_scheme_id: this.$route.params.id,
        items: [{
          id: this.activeInfo.day_hour.id,
          val: this.activeInfo.day_hour.val,
          type: this.activeInfo.day_hour.type
        }].concat(_toConsumableArray(res.map(function (v) {
          return {
            id: v.id,
            val: v.val,
            type: v.type
          };
        }))),
        extend: this.activeInfo.extend
      });
    },
    handleGroup: function handleGroup(val) {
      this.$set(this.activeInfo.extend[val], 'after', '');
      this.$set(this.activeInfo.extend[val], 'before', '');
    },
    checkExample: function checkExample(type) {
      this.$refs.example.init(type);
    }
  }
};